/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Faq_A5Inputs */

const en_pc_dl_faq_a5 = /** @type {(inputs: Pc_Dl_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The x86_64 and ARM64 builds need glibc 2.35 or newer: Ubuntu 22.04+, Debian 12+, Fedora 36+ or RHEL 10. RISC-V builds need glibc 2.39 or newer (Ubuntu 24.04+, Debian 13+). If you are unsure which package to use, the AppImage is the simplest choice.`)
};

const zh_pc_dl_faq_a5 = /** @type {(inputs: Pc_Dl_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x86_64 和 ARM64 版本需要 glibc 2.35 或更高版本：Ubuntu 22.04+、Debian 12+、Fedora 36+ 或 RHEL 10。RISC-V 版本需要 glibc 2.39 或更高版本（Ubuntu 24.04+、Debian 13+）。如果不确定该选哪种包，AppImage 最简单。`)
};

/**
* | output |
* | --- |
* | "The x86_64 and ARM64 builds need glibc 2.35 or newer: Ubuntu 22.04+, Debian 12+, Fedora 36+ or RHEL 10. RISC-V builds need glibc 2.39 or newer (Ubuntu 24.04+..." |
*
* @param {Pc_Dl_Faq_A5Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_faq_a5 = /** @type {((inputs?: Pc_Dl_Faq_A5Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Faq_A5Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_faq_a5(inputs)
	return zh_pc_dl_faq_a5(inputs)
});
export { pc_dl_faq_a5 as "pc.dl.faq.a5" }